<template>
  <v-row>
    <v-col v-if="tradeType === 'buy'" cols="12">
      <div class="py-2 d-flex align-center flex-wrap flex-sm-row flex-column">
        <span class="me-2 font-Regular-12">{{ $t("exchange.canUse") }}</span>
        <span class="me-2 font-Regular-12">{{
          $thousandMask(wallet.base, currentCoin.frontBaseCoinScale)
        }}</span>
        <span class="me-2 font-Regular-12">{{ currentCoin.baseSymbol }}</span>
        <a
          v-if="currentCoin.coinType !== 'VIRTUAL'"
          :href="
            `${baseUrl}/operations/transfer?from=${currentCoin.baseSymbol}`
          "
          class="text-yellow font-Regular-12"
        >
          {{ $t("exchange.balanceIncrease") }}
        </a>
      </div>
      <v-text-field
        v-model="buy.stopActivationPrice"
        placeholder="0"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
        @input="handleActivationPrice('buy')"
        @keyup="checkActivationPriceRules('buy')"
      >
        <template v-slot:prepend-inner>
          <p class="me-6 mb-0 font-Regular-12" style="width: 50px;">
            {{ currentCoin.baseSymbol }}
          </p>
        </template>
        <template v-slot:append>
          <p class="mb-0 font-Regular-12">
            {{ $t("exchange.activationPrice") }}
          </p>
        </template>
      </v-text-field>
      <v-text-field
        v-model="buy.stopOrderPrice"
        placeholder="0"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
        @input="setAmount('buy', 'stopOrderPrice', 'frontBaseCoinScale')"
        @keyup="checkRules('buy', 'stopOrderPrice')"
      >
        <template v-slot:prepend-inner>
          <p class="me-6 mb-0 font-Regular-12" style="width: 50px;">
            {{ currentCoin.baseSymbol }}
          </p>
        </template>
        <template v-slot:append>
          <p class="mb-0 font-Regular-12">{{ $t("exchange.buyPrice") }}</p>
        </template>
      </v-text-field>
      <v-text-field
        v-model="buy.stopAmount"
        placeholder="0"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
        @input="setAmount('buy', 'stopAmount', 'frontCoinScale')"
        @keyup="checkRules('buy', 'stopAmount')"
      >
        <template v-slot:prepend-inner>
          <p class="me-6 mb-0 font-Regular-12" style="width: 50px;">
            {{ currentCoin.coinSymbol }}
          </p>
        </template>
        <template v-slot:append>
          <p class="mb-0 font-Regular-12">{{ $t("exchange.buyAmount") }}</p>
        </template>
      </v-text-field>
      <v-slider
        class="ltr"
        color="green"
        v-model="buy.sliderPercent"
        @change="handleBuySlider"
        thumb-label="always"
        track-color="none"
        thumb-color="none"
      >
        <template v-slot:thumb-label="{ value }">
          <span class="font-Regular-12 green--text"
            >{{ value }}%</span
          ></template
        >
      </v-slider>
      <v-text-field
        v-model="buy.totalOrderAmount"
        placeholder="0"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
        @input="calculateAmount('buy')"
      >
        <template v-slot:append>
          <span class="font-Regular-12">{{ $t("exchange.totalValue") }}</span>
        </template>
      </v-text-field>
      <!--      <TotalAmountOrder-->
      <!--        :price="$removeThousand(buy.stopOrderPrice)"-->
      <!--        :amount="$removeThousand(buy.stopAmount)"-->
      <!--        side="BUY"-->
      <!--        @setPrice="setPrice"-->
      <!--      />-->
      <div
        class="d-flex justify-space-between align-center font-Regular-12 gray2--text"
      >
        <p class="font-Regular-12">{{ $t("exchange.estimatedReceipt") }}</p>
        <p class="ltr">
          <img alt="" class="mr-2" src="@/assets/image/nearAmount.svg" />
          <span>
            {{
              $thousandMask(
                buy.stopAmount.toString().replace(/,/gi, "") -
                  buy.stopAmount.toString().replace(/,/gi, "") *
                    currentCoin.takerFee,
                currentCoin.frontCoinScale
              )
            }}
          </span>
          <span class="font-Regular-12">{{ currentCoin.coinSymbol }}</span>
        </p>
      </div>

      <Fee :currentCoin="currentCoin" />

      <v-btn
        block
        color="green"
        :loading="loadBuy"
        @click="buyCrypto()"
        :disabled="disableBuy"
        class="white--text mt-8"
        depressed
        large
      >
        {{ $t("exchange.buy") }} ({{ currentCoin.coinSymbol }})
      </v-btn>
    </v-col>
    <v-col v-if="tradeType === 'sell'" cols="12">
      <div class="py-2 d-flex align-center flex-wrap flex-sm-row flex-column">
        <span class="me-2 font-Regular-12">{{ $t("exchange.canUse") }}</span>
        <span class="me-2  font-Regular-12">{{
          $thousandMask(wallet.coin, currentCoin.frontCoinScale)
        }}</span>
        <span class="me-2 font-Regular-12 ">{{ currentCoin.coinSymbol }}</span>
        <a
          v-if="currentCoin.coinType !== 'VIRTUAL'"
          :href="
            `${baseUrl}/operations/transfer?from=${currentCoin.coinSymbol}`
          "
          class="text-yellow font-Regular-12"
        >
          {{ $t("exchange.balanceIncrease") }}
        </a>
      </div>
      <v-text-field
        v-model="sell.stopActivationPrice"
        placeholder="0"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
        @input="handleActivationPrice('sell')"
        @keyup="checkActivationPriceRules('sell')"
      >
        <template v-slot:prepend-inner>
          <p class="me-6 mb-0 font-Regular-12" style="width: 50px;">
            {{ currentCoin.baseSymbol }}
          </p>
        </template>
        <template v-slot:append>
          <p class="mb-0 font-Regular-12">
            {{ $t("exchange.activationPrice") }}
          </p>
        </template>
      </v-text-field>
      <v-text-field
        v-model="sell.stopOrderPrice"
        placeholder="0"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
        @input="setAmount('sell', 'stopOrderPrice', 'frontBaseCoinScale')"
        @keyup="checkRules('sell', 'stopOrderPrice')"
      >
        <template v-slot:prepend-inner>
          <p class="me-6 mb-0 font-Regular-12" style="width: 50px;">
            {{ currentCoin.baseSymbol }}
          </p>
        </template>
        <template v-slot:append>
          <p class="mb-0 font-Regular-12">{{ $t("exchange.sellPrice") }}</p>
        </template>
      </v-text-field>
      <v-text-field
        v-model="sell.stopAmount"
        placeholder="0"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
        @input="setAmount('sell', 'stopAmount', 'frontCoinScale')"
        @keyup="checkRules('sell', 'stopAmount')"
      >
        <template v-slot:prepend-inner>
          <p class="me-6 mb-0 font-Regular-12" style="width: 50px;">
            {{ currentCoin.coinSymbol }}
          </p>
        </template>
        <template v-slot:append>
          <p class="mb-0 font-Regular-12">{{ $t("exchange.sellAmount") }}</p>
        </template>
      </v-text-field>
      <v-slider
        class="ltr"
        v-model="sell.sliderPercent"
        @change="handleSellSlider"
        thumb-label="always"
        track-color="none"
        thumb-color="none"
      >
        <template v-slot:thumb-label="{ value }">
          <span class="font-Regular-12 red--text">{{ value }}%</span></template
        >
      </v-slider>
      <v-text-field
        v-model="sell.totalOrderAmount"
        placeholder="0"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
        @input="calculateAmount('sell')"
      >
        <template v-slot:append>
          <span class="font-Regular-12">
            {{ $t("exchange.totalValue") }}
          </span>
        </template>
      </v-text-field>
      <!--      <TotalAmountOrder-->
      <!--        :price="$removeThousand(sell.stopOrderPrice)"-->
      <!--        :amount="$removeThousand(sell.stopAmount)"-->
      <!--        side="SELL"-->
      <!--        @setPrice="setPrice"-->
      <!--      />-->
      <div
        class="d-flex justify-space-between align-center font-Regular-12 gray2--text"
      >
        <p class="font-Regular-12">{{ $t("exchange.estimatedReceipt") }}</p>
        <p class="ltr">
          <img alt="" class="mr-2" src="@/assets/image/nearAmount.svg" />
          <span class="font-Regular-12">
            {{
              $thousandMask(
                (sell.stopAmount.toString().replace(/,/gi, "") -
                  sell.stopAmount.toString().replace(/,/gi, "") *
                    currentCoin.takerFee) *
                  sell.stopOrderPrice.toString().replace(/,/gi, ""),
                currentCoin.frontBaseCoinScale
              )
            }}
          </span>
          <span class="font-Regular-12">{{ currentCoin.baseSymbol }}</span>
        </p>
      </div>

      <Fee :currentCoin="currentCoin" />

      <v-btn
        block
        color="red"
        :loading="loadSell"
        @click="sellCrypto()"
        :disabled="disableSell"
        class="white--text mt-8"
        depressed
        large
      >
        {{ $t("exchange.sell") }} ({{ currentCoin.coinSymbol }})
      </v-btn>
    </v-col>

    <DisClaimerModal
      v-model="buyDisClaimerModal"
      @confirm="confirmBuyDisClaimer"
    />
    <DisClaimerModal
      v-model="sellDisClaimerModal"
      @confirm="confirmSellDisClaimer"
    />
  </v-row>
</template>
<script>
import $thousandMask from "@/mixins/thousandMask";
import { ExchangeService } from "@/services";
import $removeThousand from "@/mixins/thousandMask";
import { authMixin } from "@/mixins/authMixin";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import DisClaimerModal from "@/components/Market/exchange/tradeForms/disClaimerModal.vue";
import Fee from "@/components/Market/exchange/tradeForms/fee.vue";

export default {
  name: "preconditionOrder",
  components: { DisClaimerModal, Fee },
  mixins: [$thousandMask, $removeThousand, authMixin],
  props: {
    wallet: {
      type: Object,
      required: true,
    },
    currentCoin: {
      type: Object,
      required: true,
    },
    tradeType: {
      type: String,
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      buy: {
        stopActivationPrice: "",
        stopOrderPrice: "",
        stopAmount: "",
        totalOrderAmount: "",
        stopTurnover: 0.0,
        sliderPercent: 0,
      },
      sell: {
        stopActivationPrice: "",
        stopOrderPrice: "",
        stopAmount: "",
        totalOrderAmount: "",
        stopTurnover: 0.0,
        sliderPercent: 0,
      },
      loadBuy: false,
      loadSell: false,
    };
  },
  computed: {
    ...mapGetters({
      selectedPrice: types.marketExchange.getters.GET_SELECTED_PRICE,
    }),
    disableBuy() {
      if (this.isAdmin) return false;
      else {
        return (
          !this.currentCoin.enableStopLimit ||
          this.currentCoin.exchangeable === 2 ||
          !this.currentCoin
        );
      }
    },
    disableSell() {
      if (this.isAdmin) return false;
      else {
        return (
          !this.currentCoin.enableStopLimit ||
          this.currentCoin.exchangeable === 2 ||
          !this.currentCoin
        );
      }
    },
  },
  watch: {
    selectedPrice() {
      this.buy.stopOrderPrice = this.$thousandMask(this.selectedPrice);
      this.sell.stopOrderPrice = this.$thousandMask(this.selectedPrice);
    },
  },
  mounted: function() {
    this.buy.stopOrderPrice = this.$thousandMask(
      this.currentCoin.close,
      this.currentCoin.frontBaseCoinScale
    );
    this.sell.stopOrderPrice = this.$thousandMask(
      this.currentCoin.close,
      this.currentCoin.frontBaseCoinScale
    );
  },
  methods: {
    checkActivationPriceRules(obj) {
      this[obj].stopActivationPrice = this[obj].stopActivationPrice.replace(
        /[^\d.,]/g,
        ""
      );
    },
    handleActivationPrice(obj) {
      if (!this[obj].stopActivationPrice) return;
      const str = this[obj].stopActivationPrice.toString();
      let number = str.replace(/,/gi, "");
      this[obj].stopActivationPrice = this.$thousandMask(
        number,
        this.currentCoin.frontBaseCoinScale
      );
    },
    checkRules(obj, prop) {
      if (this[obj][prop] === "") {
        this.setSliderPercent(obj);
      } else {
        this[obj][prop] = JSON.stringify(this[obj][prop]);
        this[obj][prop] = this[obj][prop].replace(/[^\d.,]/g, "");
        let amount = this[obj].stopAmount.replace(/,/gi, "");
        let price = this[obj].stopOrderPrice.replace(/,/gi, "");
        this[obj].totalOrderAmount = this.$thousandMask(
          (parseFloat(price) || 0) * (parseFloat(amount) || 0),
          this.currentCoin.frontBaseCoinScale
        );
      }
    },
    setAmount(obj, prop, scale) {
      if (!this[obj][prop]) return;
      const str = this[obj][prop].toString();
      let number = str.replace(/,/gi, "");

      const maskedValue = this.$thousandMask(number, this.currentCoin[scale]);

      // Force update using nextTick
      this.$nextTick(() => {
        this[obj][prop] = maskedValue;
        this[obj].stopTurnover = this.toFloor(
          this.mul(this[obj].stopOrderPrice, this[obj].stopAmount)
        );
        this.setSliderPercent(obj);
      });
    },
    setSliderPercent(obj) {
      let amount = this[obj].stopAmount.replace(/,/gi, "");
      let price = this[obj].stopOrderPrice.replace(/,/gi, "");
      let account = this.wallet.coin;
      let turnOver = amount;
      if (obj === "buy") {
        account = this.wallet.base;
        turnOver = this.mul(price, amount);
      }
      this[obj].sliderPercent =
        account > 0 && parseFloat(price) > 0 && parseFloat(amount) > 0
          ? parseFloat(this.mul(this.div(turnOver, account), 100))
          : 0;
    },
    handleBuySlider(val) {
      let price = this.buy.stopOrderPrice.replace(/,/gi, ""),
        account = this.wallet.base,
        amount = 0;
      if (price > 0) {
        amount = this.mul(this.mul(this.div(account, price), val), 0.01);
      }
      this.buy.stopAmount = amount;
      this.buy.limitTurnover = this.toFloor(
        this.mul(this.buy.stopAmount, price)
      );
      this.setAmount("buy", "stopAmount", "frontCoinScale");
      this.checkRules("buy", "stopAmount");
    },
    handleSellSlider(val) {
      let price = this.sell.stopOrderPrice.replace(/,/gi, "");
      this.sell.stopAmount = this.mul(this.mul(this.wallet.coin, val), 0.01);
      this.sell.limitTurnover = this.toFloor(
        this.mul(this.buy.stopAmount, price)
      );
      this.setAmount("sell", "stopAmount", "frontCoinScale");
      this.checkRules("sell", "stopAmount");
    },
    setPLateData(price) {
      this.buy.stopOrderPrice = this.$thousandMask(
        price,
        this.currentCoin.frontBaseCoinScale
      );
      this.sell.stopOrderPrice = this.$thousandMask(
        price,
        this.currentCoin.frontBaseCoinScale
      );

      this.buy.stopAmount = "";
      this.setSliderPercent("buy");
      this.sell.stopAmount = "";
      this.setSliderPercent("sell");
    },
    buyCrypto(isConfirmed = false) {
      const stopActivationPrice = this.buy.stopActivationPrice.replace(
        /,/gi,
        ""
      );
      const stopOrderPrice = this.buy.stopOrderPrice.replace(/,/gi, "");
      const stopAmount = this.buy.stopAmount.replace(/,/gi, "");
      if (!stopActivationPrice || stopActivationPrice === "0") {
        this.$toast.error(this.$t("exchange.enterActivationPrice"));
        return;
      }
      if (!stopOrderPrice || stopOrderPrice === "0") {
        this.$toast.error(this.$t("exchange.enterBuyPrice"));
        return;
      }
      if (!stopAmount || stopAmount === "0") {
        this.$toast.error(this.$t("exchange.enterBuyAmount"));
        return;
      }

      this.loadBuy = true;
      let payload = {
        symbol: this.currentCoin.symbol,
        orderPrice: stopOrderPrice,
        activationPrice: stopActivationPrice,
        amount: stopAmount,
        direction: "BUY",
        orderType: "LIMIT_PRICE",
        isConfirmed: isConfirmed,
        confirmationDisclaimer: isConfirmed
          ? this.$t("exchange.disClaimerModal.description")
          : null,
      };
      ExchangeService.addPreconditionOrder(payload)
        .then((res) => {
          if (res.data.code === 40901) {
            this.buyDisClaimerModal = true;
          } else {
            if (res.data.code !== 500) {
              this.$toast.success(this.$t("exchange.success"));
            }
            this.$emit("refresh");
            this.buy.stopAmount = "";
            this.buy.sliderPercent = 0;
          }
        })
        .catch((err) => {
          this.$toast.error(err.message);
        })
        .finally(() => {
          this.loadBuy = false;
        });
    },
    sellCrypto(isConfirmed = false) {
      const stopActivationPrice = this.sell.stopActivationPrice.replace(
        /,/gi,
        ""
      );
      const stopOrderPrice = this.sell.stopOrderPrice.replace(/,/gi, "");
      const stopAmount = this.sell.stopAmount.replace(/,/gi, "");
      if (!stopActivationPrice || stopActivationPrice === "0") {
        this.$toast.error(this.$t("exchange.enterActivationPrice"));
        return;
      }
      if (!stopOrderPrice || stopOrderPrice === "0") {
        this.$toast.error(this.$t("exchange.enterSellPrice"));
        return;
      }
      if (!stopAmount || stopAmount === "0") {
        this.$toast.error(this.$t("exchange.enterSellAmount"));
        return;
      }
      this.loadSell = true;
      let payload = {
        symbol: this.currentCoin.symbol,
        orderPrice: stopOrderPrice,
        activationPrice: stopActivationPrice,
        amount: stopAmount,
        direction: "SELL",
        orderType: "LIMIT_PRICE",
        isConfirmed: isConfirmed,
        confirmationDisclaimer: isConfirmed
          ? this.$t("exchange.disClaimerModal.description")
          : null,
      };
      ExchangeService.addPreconditionOrder(payload)
        .then((res) => {
          if (res.data.code === 40901) {
            this.sellDisClaimerModal = true;
          } else {
            if (res.data.code !== 500) {
              this.$toast.success(this.$t("exchange.success"));
            }
            this.$emit("refresh");
            this.sell.stopAmount = "";
            this.sell.sliderPercent = 0;
          }
        })
        .catch((err) => {
          this.$toast.error(err.message);
        })
        .finally(() => {
          this.loadSell = false;
        });
    },

    calculateAmount(obj) {
      if (!this[obj].totalOrderAmount) return;
      const str = this[obj].totalOrderAmount.toString();
      let number = str.replace(/,/gi, "");
      const maskedValue = this.$thousandMask(
        number,
        this.currentCoin.frontBaseCoinScale
      );
      let price = this[obj].stopOrderPrice.replace(/,/gi, "");
      // Force update using nextTick
      this.$nextTick(() => {
        this[obj].totalOrderAmount = maskedValue;
        this[obj].stopAmount = parseFloat(number) / parseFloat(price);
        this.setAmount(obj, "stopAmount", "frontCoinScale");
      });
    },
    //// helping methods
    mul(a, b) {
      let c = 0,
        d = a.toString(),
        e = b.toString();
      if (d.split(".")[1]) c += d.split(".")[1].length;
      if (e.split(".")[1]) c += e.split(".")[1].length;
      return (
        (Number(d.replace(".", "")) * Number(e.replace(".", ""))) /
        Math.pow(10, c)
      );
    },
    div(arg1, arg2) {
      let t1 = 0,
        t2 = 0,
        r1,
        r2;
      if (arg1.toString().split(".")[1])
        t1 = arg1.toString().split(".")[1].length;
      if (arg2.toString().split(".")[1])
        t2 = arg2.toString().split(".")[1].length;

      r1 = Number(arg1.toString().replace(".", ""));
      r2 = Number(arg2.toString().replace(".", ""));
      return (r1 / r2) * Math.pow(10, t2 - t1);
    },
    toFloor(number, scale = 8) {
      if (Number(number) === 0) {
        return 0;
      }
      let __str = number + "";
      if (__str.indexOf("e") > -1 || __str.indexOf("E") > -1) {
        let __num = Number(number).toFixed(scale + 1),
          __str = __num + "";
        return __str.substring(0, __str.length - 1);
      } else if (__str.indexOf(".") > -1) {
        if (scale === 0) {
          return __str.substring(0, __str.indexOf("."));
        }
        return __str.substring(0, __str.indexOf(".") + scale + 1);
      } else {
        return __str;
      }
    },

    confirmBuyDisClaimer() {
      this.buyCrypto(true);
    },
    confirmSellDisClaimer() {
      this.sellCrypto(true);
    },
  },
};
</script>
<style scoped lang="scss"></style>
